import { render, staticRenderFns } from "./modalForca.vue?vue&type=template&id=00bd337c"
import script from "./modalForca.vue?vue&type=script&lang=js"
export * from "./modalForca.vue?vue&type=script&lang=js"
import style0 from "./modalForca.vue?vue&type=style&index=0&id=00bd337c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports